export default "__VITE_ASSET__YAUkSjW1__"